import React from "react";
import { Route, Switch } from "react-router-dom";
import { Area } from "types";
import { TemplateEditorPage } from "./TemplateEditorPage";
import { TemplateChangesPage } from "./TemplateChangesPage";
import { Templates } from "./Templates";

export const TemplateRoutes: React.VFC = () => (
  <Switch>
    <Route path={Area.CreateContent_Templates_New}>
      <TemplateEditorPage />
    </Route>
    <Route path={Area.CreateContent_Templates_Changes}>
      <TemplateChangesPage />
    </Route>
    <Route path={Area.CreateContent_Templates_Edit}>
      <TemplateEditorPage />
    </Route>
    <Route path={`${Area.CreateContent_Templates}/:id`}>
      <TemplateEditorPage />
    </Route>
    <Route path={Area.CreateContent_Templates}>
      <Templates />
    </Route>
  </Switch>
);
